export default __webpack_public_path__ + "static/media/DragOver.8108df5f.svg";